export default __webpack_public_path__ + "static/filed-e2d51aac3bb21cee0aec91f44c9e7406.png";